<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item>
              <span slot="label">
                项 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目
              </span>
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="日期">
              <a-range-picker
                style="max-width: 200px;min-width: 100%"
                @change="onChange"
                v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="6" :md="6" :sm="24">
            <a-form-item label="客户名称">
              <a-input
                :disabled="showable"
                placeholder="请输入客户名称"
                v-model="queryParam.customerName"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="机械类别">
              <a-input
                :disabled="showable"
                placeholder="请输入机械类别"
                v-model="queryParam.type"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate=undefined}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
        <div class="table-operator">
          <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
        </div>
      </a-form>
    </div>
    <s-table
      :isInquire="false"
      bordered
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { fetchList, download } from '@/api/statement/outMachine'

export default {
  name: 'OutMachineCost',
  mixins: [TableMixin],
  data () {
    return {
      projectList: [], // 项目
      showable: false,
      clearDate: undefined,
      tableData: [],
      queryParam: {
        projectId: undefined,
        customerName: undefined,
        startTime: undefined,
        endTime: undefined,
        type: undefined
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '客户名称',
          dataIndex: 'customerName'
        },
        {
          title: '机械类别',
          dataIndex: 'type'
        },
        {
          title: '总金额',
          dataIndex: 'amount',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
    },
    download () {
      download({
        ...this.queryParam,
        isStatement: '1' // 标识是成本分析里的导出
      }).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '外雇机械成本统计.xlsx'
        link.click()
      }).catch(() => {
        this.$message.warning('下载失败')
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
